import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Spin2 } from "components";
import { createBundle } from "../../actions";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toastAlert } from "@paylixecommerce/shared/components";
import { ProductMultiSelect, SimpleSelect, Text } from "components/fields";
import { useHistory } from "react-router-dom";
import config from "constants/config";
import { CartIcon } from "../../../../../layouts/dashboard/sidebar/icons/icons/icons";
import { ProductIcon } from "../../../../invoices/invoices/table";

import "./../style.scss";


const validationSchema = Yup.object().shape({
	title: Yup.string().required('Title is required'),
	products: Yup.array().min(1, "Select at least one field").of(Yup.object().shape({
		label: Yup.string(),
		value: Yup.string()
	}).nullable()).nullable().required('Product is required'),
	discount_amount: Yup.string().required('Discount amount is required')
});


const CreateNewBundle = () => {

	const [initialValues] = useState({
		title: '',
		products: [],
		discount_type: "PERCENTAGE",
		discount_amount: 10,
	});
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const history = useHistory();

	const onSubmit = (values) => {
		setLoading(true);

		values.products = values.products.map(({value}) => value).toString();

		dispatch(createBundle(values))
			.then(res => {
				toastAlert('success', res.message);
				history.push(`/upselling`)
			})
			.catch(err => {
				toastAlert('error', err ? err.error : "");
			})
			.finally(() => {
				setLoading(false)
			});
	}

	let form = useFormik({initialValues, onSubmit, enableReinitialize: true, validationSchema});


	return (
		<>

			<div className="edit-modal-header">
				<div className="edit-modal-header-title">
					New Products Bundle
				</div>
				<div className="edit-modal-header-ref">
					<div className="create-bundle-screen-example">
						<div className="create-bundle-screen-example-header">
							<div>
								<div className="create-bundle-screen-example-header-title">{form.values.title || "Example Bundle"}</div>
								<div>Save <b style={{ color: "var(--black9)" }}>{form.values.discount_type === "FIXED" ? "$" : ""}{form.values.discount_amount || 33}{form.values.discount_type === "PERCENTAGE" ? "%" : ""} </b> by adding one more products to you cart with our discounts.</div>
							</div>
							<div>
								<Button size="large" className="text-nowrap"><CartIcon color="currentColor" />&nbsp;&nbsp;Add All to Cart</Button>
							</div>
						</div>
						<div className="create-bundle-screen-example-body">
							<div className="create-bundle-screen-example-item">
								<div className="create-bundle-screen-example-item-img">
									<ProductIcon />
								</div>
								<div className="d-flex flex-column">
									<div className="create-bundle-screen-example-item-title">
										Product 1
									</div>
									<div className="create-bundle-screen-example-item-price">
										<span>$19.99</span>
										<i>$29.99</i>
									</div>
								</div>
							</div>
							<div className="create-bundle-screen-example-item">
								<div className="create-bundle-screen-example-item-img">
									<ProductIcon />
								</div>
								<div className="d-flex flex-column">
									<div className="create-bundle-screen-example-item-title">
										Product 2
									</div>
									<div className="create-bundle-screen-example-item-price">
										<span>$19.99</span>
										<i>$29.99</i>
									</div>
								</div>
							</div>
							<div className="create-bundle-screen-example-item">
								<div className="create-bundle-screen-example-item-img">
									<ProductIcon />
								</div>
								<div className="d-flex flex-column">
									<div className="create-bundle-screen-example-item-title">
										Product 3
									</div>
									<div className="create-bundle-screen-example-item-price">
										<span>$19.99</span>
										<i>$29.99</i>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<form onSubmit={form.handleSubmit} className="edit-modal-body create-bundle-screen-form mb-0">

				<Text label="Bundle Name" name="title" placeholder="Enter Name" {...form} />
				<ProductMultiSelect name="products" {...form} />

				<div className="create-bundle-screen-one-row">
					<SimpleSelect label="Type" options={config.DISCOUNT_TYPE} name="discount_type" {...form} />
					<Text label="Discount Amount" noteUnder name="discount_amount" {...form} placeholder="10" />
				</div>

			</form>

			<div className="edit-modal-footer">
				<Button type="button" size="large" variant="secondary" onClick={() => history.push('/upselling')}>
					Close
				</Button>
				<Button type="button" size="large" onClick={form.handleSubmit}>
					{loading ? <Spin2 /> : "Save Products Bundle"}
				</Button>
			</div>
		</>
	)
}

export default CreateNewBundle
